import { Tooltip, NaosButton } from '@dtsl/react';

import useVideoContext from '../../../hooks/useVideoContext/useVideoContext';
import { useTranslation } from 'react-i18next';

export default function EndCallButton(props: { className?: string }) {
  const { room } = useVideoContext();
  const { t } = useTranslation();

  return (
    <Tooltip text={t('ROOM.LEAVE_TOOLTIP')} placement="top">
      <NaosButton
        id="video-calls-end-call"
        className={props.className}
        variant="primary"
        color="destructive"
        label={t('ROOM.LEAVE')}
        onClick={() => room!.disconnect()}
        data-cy-disconnect
      ></NaosButton>
    </Tooltip>
  );
}
